"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.departurePlaceholder = exports.departurePickerName = exports.INPUT_CONTROL_HEIGHT = void 0;
var departurePickerName = 'lt-departure-picker';
exports.departurePickerName = departurePickerName;
var departurePlaceholder = 'Город вылета';
exports.departurePlaceholder = departurePlaceholder;
var INPUT_CONTROL_HEIGHT = '64px';
exports.INPUT_CONTROL_HEIGHT = INPUT_CONTROL_HEIGHT;